import { render, staticRenderFns } from "./ViewCourse.vue?vue&type=template&id=58291f46&scoped=true"
import script from "./ViewCourse.vue?vue&type=script&lang=js"
export * from "./ViewCourse.vue?vue&type=script&lang=js"
import style0 from "./ViewCourse.vue?vue&type=style&index=0&id=58291f46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58291f46",
  null
  
)

export default component.exports